import React from "react";

const HoRoadMarking = ({ size = 24, color = "currentColor" }) => (
  // icon
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} xmlns="http://www.w3.org/2000/svg">
    {/* road body */}
    <rect x="6" y="3" width="12" height="18" rx="2" ry="2" strokeWidth="1.6" />

    {/* center dashed line */}
    <line x1="12" y1="5" x2="12" y2="9" strokeWidth="1.4" strokeLinecap="round" />
    <line x1="12" y1="11" x2="12" y2="13" strokeWidth="1.4" strokeLinecap="round" />
    <line x1="12" y1="15" x2="12" y2="17" strokeWidth="1.4" strokeLinecap="round" />

    {/* roller body */}
    <rect x="9" y="17.5" width="6" height="2.3" rx="0.7" strokeWidth="1.2" />

    {/* roller arm */}
    <path d="M12 19.8 L12 22" strokeWidth="1.2" strokeLinecap="round" />

    {/* roller grip */}
    <rect x="11.2" y="22" width="1.6" height="1.5" rx="0.5" fill={color} stroke="none" />
  </svg>
);

export default HoRoadMarking;
